import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormGroup,
  Input,
  Radio,
  Switch,
  Tab,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
  useTheme
} from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Buttons } from './components/Buttons';
import { Chips } from './components/Chips';
import { Colors } from './components/Colors';
import { Fonts } from './components/Fonts';
import { Icons } from './components/Icons';



export type BasicThemeActivityProps = {};

export const BasicThemeActivity = (props: BasicThemeActivityProps) => {
  const theme = useTheme();
  return (
    <>
      <Box sx={{
        display: 'flex', flexDirection: 'column', rowGap: 2, overflowX: 'scroll'
      }}
      >
        <Box display='flex' flexDirection='column' alignItems='center'>
          <Box display='flex' alignSelf='stretch' justifyContent='center' borderBottom='1px black solid'>
            <Typography variant='h1'>Colors</Typography>
          </Box>
          <Colors />
        </Box>

        <Box display='flex' flexDirection='column' alignItems='center'>

          <Box display='flex' alignSelf='stretch' justifyContent='center' borderBottom='1px black solid'>
            <Typography variant='h1'>Typography</Typography>
          </Box>
          <Fonts />
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center'>

          <Box display='flex' alignSelf='stretch' justifyContent='center' borderBottom='1px black solid'>
            <Typography variant='h1'>Base Buttons</Typography>
          </Box>
          <Buttons />
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center'>

          <Box display='flex' alignSelf='stretch' justifyContent='center' borderBottom='1px black solid'>
            <Typography variant='h1'>Icons</Typography>
          </Box>
          <Icons />
        </Box>
        <Box>
        </Box>

        <Tabs value={1} indicatorColor='primary'>
          <Tab value={1} label='Company Snapshot' />
          <Tab value={2} label='EPS & Revenue' />
          <Tab value={3} label='Relative Valuation' />
          <Tab value={4} label='Financials & Ratios' />
        </Tabs>

        <Box>
          {theme.components?.MuiChip?.variants?.map((node, i) => {
            const variantNode: any = node;
            return (
              <Chip
                key={i}
                {...node.props}
                label={variantNode.props.variant!}
              />

            );
          })}
        </Box>
        <Box
          paddingY={2}
        >
          <Typography variant='h2'>Form Fields</Typography>
          <FormGroup>
            <FormControlLabel disableTypography control={<Radio />} label={<Typography variant='h5'>Create</Typography>} />
          </FormGroup>
          <FormGroup>
            <FormControlLabel disableTypography control={<Switch />} label={<Typography variant='h5'>Create</Typography>} />
          </FormGroup>
          <Box
            display='flex'
            flexDirection='row'
            bgcolor='red'
          >
            <FormControlLabel
              sx={{
                backgroundColor: 'blue'
              }}
              disableTypography
              control={<Checkbox />}
              label={<Typography variant='h5'>Create</Typography>}
            />
            <Typography variant='body1'>Hello world</Typography>
          </Box>
          <FormControl>
            {/* <Typography variant='formLabel'>State</Typography> */}

            {/* <InputLabel variant='standard'>state</InputLabel> */}
            <Input type='text' required={true} value='test' placeholder='Testing placeholder' />
          </FormControl>
        </Box>
        <Box
          paddingY={2}
        >
          <Typography variant='h2'>Table</Typography>
          <TableContainer>
            <TableHead>
              <TableRow>
                <TableCell variant='head'>Col1</TableCell>
                <TableCell variant='head'>Col2</TableCell>
                <TableCell variant='head'>Col3</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell variant='body'>Col1</TableCell>
                <TableCell variant='body'>Col2</TableCell>
                <TableCell variant='body'>Col3</TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant='link'>Col1</TableCell>
                <TableCell variant='body'>Col2</TableCell>
                <TableCell variant='body'>Col3</TableCell>
              </TableRow>
            </TableBody>
            <Box>


            </Box>
          </TableContainer>
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center'>
          <Box display='flex' alignSelf='stretch' justifyContent='center' borderBottom='1px black solid'>
            <Typography variant='h1'>Chips</Typography>
          </Box>
          <Chips />
        </Box>
      </Box>
      <Outlet />
    </>

  );
};
